import React from "react";
import "./style.css";
import {QuestionnaireSelect} from "../../../../components/QuestionnaireSelect";

export const LastMealTime = (props) => {
  const data = {
    title: "What time do you have last meal?",
    list: [{
      content: "Between 4 and 6 pm",
    },{
      content: "Between 6 and 8 pm",
    },{
      content: "Between 8 and 10 pm",
    },{
      content: "I usually skip dinner",
    },]
  };

  return (
    <div className="gallery-page">
      <QuestionnaireSelect list={data} {...props} />
    </div>
  );
};
